import React from 'react';
import { Grid, TextField } from '@material-ui/core';

import { KeywordInclusionContext } from '../KeywordInclusionContext';
import { theme } from '../../../theme';
import { EditAction } from '../../../shared/enum/EditAction';
import { KeywordModel, keywordModelInitial } from '../../../Models/KeywordModel';
import { BasicConfirmDialog } from '../../../shared/components/BasicConfirmDialog';
import { homeContextInitial } from '../../Home/HomeContext';

export function KeywordInclusionAddNewKeywordDialog() {

    const keywordInclusionContext = React.useContext(KeywordInclusionContext);

    const [newKeywordDescription, setNewKeywordDescription] = React.useState<string>('');

    const handleClearAndCloseModal = () => {
        setNewKeywordDescription('');
        keywordInclusionContext.setOpenAddNewKeywordDialog(false);
    };

    const handleAddNew = () => {
        const keywordList: KeywordModel[] = JSON.parse(JSON.stringify(keywordInclusionContext.keywordList));

        const hasKeyword = keywordList.findIndex(k => k.description.toLowerCase() === newKeywordDescription.toLowerCase());

        if(hasKeyword < 0) {
            
            const newKeyword = {...keywordModelInitial};
            newKeyword.description = newKeywordDescription;
            newKeyword.editAction = EditAction.INSERT;

            keywordList.push(newKeyword);

            const noneElements = keywordList.filter((k: KeywordModel) => k.description.toLowerCase() === 'nenhum');
            const otherElements = keywordList.filter((k: KeywordModel) => k.description.toLowerCase() !== 'nenhum');
            const sortedKeywords = sortAlphabetically(otherElements); 
            keywordInclusionContext.setKeywordList([...noneElements, ...sortedKeywords]);

            keywordInclusionContext.setSelectedKeyword(newKeyword);

            handleClearAndCloseModal();
        }
        else {
            homeContextInitial.showSuccess('Já existe uma palavra-chave com essa descrição associada a este cliente.');
        }

    };

    const sortAlphabetically = (keywordList: KeywordModel[]) => {
        return keywordList.sort((a: KeywordModel, b: KeywordModel) =>
            (a.description).localeCompare(b.description));
    };

    const getModal = () => {
        return (
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        id='search-keyword'
                        value={newKeywordDescription}
                        variant="outlined"
                        label='Palavras-chave/tags'
                        onChange={(event: React.ChangeEvent<HTMLInputElement>) => { setNewKeywordDescription(event.target.value); }} />
                </Grid>
            </Grid>
        );
    };

    return (
        <BasicConfirmDialog
            title={'Inclusão de nova palavra-chave'}
            description={'Insira a descrição para adicionar a palavra.'}
            handleFirstButton={() => handleClearAndCloseModal()}
            handleSecondButton={() => handleAddNew()}
            textFirstButton='DESCARTAR'
            textSecondButton='SALVAR'
            open={ keywordInclusionContext.openAddNewKeywordDialog }
            children={ getModal() }
            cssProperties={{ 
                minWidth: '800px',
                maxWidth: '800px',
                padding: '1rem',
                colorFirstButton: theme.palette.primary.main,
                justifyButtons: 'flex-end',
                titleVariant: 'h4',
                descriptionVariant: 'body1'
            }} />
    );
}